export default __webpack_public_path__ + "static/Wild-Poppy-Logo-be744185a7b4a52cf5525def60452f2c.jpg";